window.addEventListener("load", function() {
    var radioInputs = document.querySelectorAll('input[type="radio"][name="Type"]');
    var sizeRadioInputs = document.querySelectorAll('input[type="radio"][name="Size"]');
    var customSizeInputs = document.querySelector('input[type="radio"][value="Custom"]');
    var addOnOption = document.querySelector('.custom_size_option_addon');
    var addOnOptionInputs = document.querySelectorAll('.custom_size_option_addon input');
    var customSizeOptionOutputs = document.querySelectorAll('.custom_size_option_addon_img  span[data-size-name]');
    var ymqBoxes = document.querySelectorAll('.ymq-options-box');
    var sizeFieldset = document.querySelector('input[type="radio"][name="Size"]').closest('fieldset');
    var ymqFirstBox = document.querySelector('.ymq-options-box')
    function updateSizeFieldset() {
    var selectedValue = document.querySelector('input[type="radio"][name="Type"]:checked').value;

      if (selectedValue === "Unstitched") {
         addOnOptionInputs.forEach(function(input) {
              input.disabled = true;
          });
        sizeRadioInputs[0].click(); 
        sizeFieldset.style.display = 'none';
         ymqBoxes.forEach((div) => {
          if (div.classList.contains("new-add")) {
            div.style.display = "block";
          } else {
            div.style.display = "none";
          }
        });
      }else{
        sizeRadioInputs[2].click();
        sizeRadioInputs.forEach(function (input) {
          input.classList.remove('disabled');
        })
        sizeFieldset.style.display = 'block';
        ymqBoxes.forEach((div, index) => {
          if (div.classList.contains("new-add")) {
            div.style.display = "none";
          } else {
            div.style.display = "block";
          }
        });
         // addOnOptionInputs.forEach(function(input) {
         //      input.disabled = true;
         //  });
      }    
  }
    customSizeInputs.addEventListener('click', function () {
      addOnOption.style.display = 'block';
       addOnOptionInputs.forEach(function(input) {
              input.disabled = false;
          });
    })
  updateSizeFieldset()

   radioInputs.forEach(function(radio) {
    radio.addEventListener("change", updateSizeFieldset);
  });

     radioInputs.forEach(function(radio) {
    radio.addEventListener("click", function(){
    addOnOption.style.display = 'none'; 
       addOnOptionInputs.forEach(input => {
         input.value = '';
        });
        customSizeOptionOutputs.forEach(output => {
              output.innerText = '';
          });

       // addOnOptionInputs.forEach(function(input) {
       //        input.disabled = true;
       //    });
    });
  });

sizeRadioInputs.forEach(function(radio, index) {
    if (index !== sizeRadioInputs.length - 1) {
        radio.addEventListener("click", function () {
        addOnOption.style.display = "none";
        addOnOptionInputs.forEach(input => {
         input.value = '';
        });
        customSizeOptionOutputs.forEach(output => {
              output.innerText = '';
          });
          //  addOnOptionInputs.forEach(function(input) {
          //     input.disabled = true;
          // });
        });
    }
});
  
customSizeInputs.addEventListener('click', function() {
    addOnOption.style.display = "block";
      console.log("your code is running my boy")
  
    var customSizesInputs = document.querySelectorAll('.custom_size_option_addon_input input');
    var addToCartButton = document.querySelector('button.product-form__submit');
    setTimeout(function() {
      console.log("your code is running my boy")
      addToCartButton.disabled = true;
    }, 1000);

    customSizesInputs.forEach(function(input) {
      input.addEventListener('input', toggleAddToCartButton);
    });
   addOnOptionInputs.forEach(function(input) {
      input.disabled = false;
  });
  
    function toggleAddToCartButton() {
      var allInputsHaveValue = Array.from(customSizesInputs).every(input => input.value.trim() !== '');    
      addToCartButton.disabled = !allInputsHaveValue;
    }
})

  
})


document.addEventListener("DOMContentLoaded", function() {
  var menuSvgs = document.querySelectorAll(".menu-svgs");
  var mainUl = document.querySelectorAll(".appear-delay-4");
  menuSvgs.forEach(function(element) {
    element.addEventListener("click", function() {
      this.classList.toggle("highlight");
      mainUl.forEach(function () {
      this.classList.toggle("highlight");
      })
    });
  });
});



// document.addEventListener('DOMContentLoaded', function() {
//   const body = document.querySelector('body');
//   if (body.classList.contains('product--template')) {
//     const typeVariants = document.querySelectorAll('variant-radios input[type="radio"][data-variant-name="type"]');
//     const sizeVariants = document.querySelectorAll('variant-radios input[type="radio"][data-variant-name="size"]');
//     const sizeFieldsetElement = document.querySelector('.product-form__input[data-size]');
//     const customSizeOptionAddon = document.querySelector('.custom_size_option_addon')
//     const customSizeOptionInputs = document.querySelectorAll('.input-full');
//     const customSizeOptionOutputs = document.querySelectorAll('.custom_size_option_addon_img  span[data-size-name]');
//     const atcButton = document.querySelector('button.product-form__submit.button');
//     const atcButtonText = atcButton.querySelector('span');  
//     const custominputsizes = document.querySelectorAll('.custom__size-input');
//     const addonProductContainer = document.querySelector('.addon__product-wrap'); 
//     const addonProductInput = document.querySelectorAll('.addon-product__input');
//     const addonProductQuantityInput = document.querySelectorAll('.addon-product__quantity');
//     if (typeVariants) {
//       typeVariants.forEach(radioInput => {
//         const radioVariantValue = radioInput.getAttribute('data-variant-value');
//         if (radioVariantValue === 'unstitched' && radioInput.checked) {
//           sizeVariants[0].click();
//           sizeFieldsetElement.style.display = 'none';
//           if (addonProductContainer) {
//             addonProductContainer.style.display = 'none'
//             addonProductInput.forEach(function(checkbox) {
//               checkbox.checked = false;
//             });
//             addonProductQuantityInput.forEach(function(quantity) {
//               quantity.disabled = true;
//             });
//           }
//         } else if (radioVariantValue === 'stitched' && radioInput.checked) {
//           sizeVariants[1].click();
//           sizeFieldsetElement.style.display = 'block';
//           if (addonProductContainer) {
//             addonProductContainer.style.display = 'block';
//           }         
//         }
//         radioInput.addEventListener('change', function(event) {
//           const dataVariantValue = this.getAttribute('data-variant-value');
    
//           if (dataVariantValue === 'unstitched') {
//             sizeVariants[0].click();
//             sizeFieldsetElement.style.display = "none";                
//             custominputsizes.forEach(function(checkbox) {
//               checkbox.checked = false;
//             });

//             if (addonProductContainer) {
//               addonProductContainer.style.display = 'none';
//               addonProductInput.forEach(function(checkbox) {
//                 checkbox.checked = false;
//               });
//               addonProductQuantityInput.forEach(function(quantity) {
//                 quantity.disabled = true;
//               });
//             }
            
//             if (customSizeOptionAddon) {
//               customSizeOptionAddon.style.display = 'none';
//               customSizeOptionInputs.forEach(input => {
//                 input.value = '';
//               });
//               customSizeOptionOutputs.forEach(output => {
//                 output.innerText = '';
//               });
//             }
//           } else if (dataVariantValue === 'stitched') {  
//             sizeVariants[1].click();
//             sizeFieldsetElement.style.display = "block";
//             if (addonProductContainer) {
//               addonProductContainer.style.display = 'block';  
//             }
//           }
//         });
//       });
//     }

//     sizeVariants.forEach(function(checkbox) {
//         checkbox.addEventListener('click', function() {
//       if (checkbox.getAttribute('value') === 'Custom') {
//         customSizeOptionAddon.style.display = "block";
//         setTimeout(toggleAddToCartButton, 500);
//         // toggleAddToCartButton();
//       }
//       else{
//         customSizeOptionAddon.style.display = "none";
//           atcButton.disabled = false;
//          customSizeOptionInputs.forEach(input => {
//           input.value = '';
//         });
//         customSizeOptionOutputs.forEach(output => {
//           output.innerText = '';
//         });
//       }
//       });
//     });

//     if (addonProductContainer) {
//       addonProductInput.forEach(input => {
//         input.addEventListener('change', function() {
//           const targetId = input.getAttribute('data-id');
//           const targetInput = document.getElementById(targetId);
      
//           if (input.checked) {
//             targetInput.disabled = false;
//           } else {
//             targetInput.disabled = true;
//           }
//         });
//       });
//     }
//     function toggleAddToCartButton() {
//       const allInputsHaveValue = Array.from(customSizeOptionInputs).every(input => input.value.trim() !== '');    
//       if (atcButtonText.textContent.trim() ===  'Sold out'){
//         atcButton.disabled = true;
//       } else {
//         atcButton.disabled = !allInputsHaveValue;
//       }
//     }
  
//     if (customSizeOptionInputs) {
//       customSizeOptionInputs.forEach(input => {
//         input.addEventListener('input', toggleAddToCartButton);
//       });    
//     }
//   }
// });


document.addEventListener('DOMContentLoaded', function() {
  var customSizeInputs = document.querySelectorAll('.custom_size_option_addon_input input');

  customSizeInputs.forEach(function(input) {
    input.addEventListener('keyup', function() {
      var inputSize = this.getAttribute('data-name');
      var sSize = document.querySelector('span[data-size-name="' + inputSize + '"]');
      sSize.innerHTML = this.value;
    });
  });
});
